import { Container, Col, Row, Button, Pagination } from "react-bootstrap";
import BackArrow from "../../components/backArrow";
import Rating from "@mui/material/Rating";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Updatefoodform from "../Updatefoodform";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Reportbox from "../../components/Reportbox";
import Reportselectezibox from "../../components/Report to selectezi";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import RatingModel from "../../components/ProductsRating";
import ShareModel from "../../components/Sharemodel";
import ShareOption from "../../components/Shareoption";
import { useNavigate } from "react-router-dom";
import PlaceIcon from "@mui/icons-material/Place";
import ReportIcon from "@mui/icons-material/Report";
import StarIcon from "@mui/icons-material/Star";
import ShareIcon from "@mui/icons-material/Share";
import ChatIcon from "@mui/icons-material/Chat";
import { Form, FormControl } from "react-bootstrap";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import ConnectProfileModal from "../../components/Connect_Modal_Buy";
import { useGetAllConnectedQuery } from "../../features/connection/connectionApiSlice";
import Suggestionbox from "../../components/Suggestionbox";
import ReplyIcon from "@mui/icons-material/Reply";
import { FailedNotify, SuccessNotify } from "../../constants/tostify";
import { useSelector } from "react-redux";
import { getAsset } from "../../helpers/helper";
import dummyezi from "../../assets/images/dummy/dummyezi.png";
import RedoIcon from "@mui/icons-material/Redo";
import CampaignIcon from "@mui/icons-material/Campaign";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import QRCode from "qrcode.react";
import PeopleRatingsModal from "../../components/Rating_People";
import GradeIcon from "@mui/icons-material/Grade";
import {
  useShopData,
  useShopRating,
  useFoodItems,
  useFoodItemSearch,
  useUserData,
  useSuggestion,
} from "../../hooks/useFoodRestaurantShop";
import { getImageWithFallback, getImageProps } from "../../helpers/imageHelper";
import { decodeId } from "../../utils/idObfuscator";

const Foodandrestaurantbuy = () => {
  const { shopid: rawShopid } = useParams();
  const shopid = decodeId(rawShopid);
  const { name } = useSelector((state) => state.user);
  const navigate = useNavigate();

  // RTK Query Hooks
  const { shopData, isLoading: shopLoading } = useShopData(shopid);
  const { rating: showrating, isLoading: ratingLoading } =
    useShopRating(shopid);
  const { foodItems, isLoading: foodItemsLoading } = useFoodItems(shopid);
  const { userData } = useUserData(name?._id);
  const { handleSearch: filterFood, searchResults } = useFoodItemSearch();
  const { handlePostSuggestion, isLoading: suggestionLoading } =
    useSuggestion();

  // Fetch this user's connections so the "Send Connection Request" link
  // reflects the real state for THIS shop instead of a static label.
  const { data: connectedDataResponse } = useGetAllConnectedQuery(
    { userid: name?._id },
    { skip: !name?._id, refetchOnMountOrArgChange: true }
  );
  const matchesShop = (list, shopId) =>
    (list || []).some(
      (c) =>
        c.senderid === shopId ||
        c.recieverid === shopId ||
        c.sendershopid === shopId ||
        c.recievershopid === shopId
    );
  const isThisShopRequested = matchesShop(
    connectedDataResponse?.requested,
    shopData?._id
  );

  // Local state
  const [showpeoplerating, setShowpeoplerating] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const [lgShowreport, setLgShowreport] = useState(false);
  const [selectezireport, setSelectezireport] = useState(false);
  const [smShow, setSmShow] = useState(0);
  const [showconnect, setShowconnect] = useState(false);
  const [showshare, setShowshare] = useState(false);
  const [show, setShow] = useState(false);
  const [lgShow, setLgShow] = useState(0);
  const [key, setKey] = useState("home");
  const [showavaliable, setShowavaliable] = useState(false);
  const [Open, setOpen] = useState(0);
  const [showqr, setShowqr] = useState(0);
  const [currentPageRegular, setCurrentPageRegular] = useState(1);
  const [currentPageSpecial, setCurrentPageSpecial] = useState(1);
  const [currentPageSale, setCurrentPageSale] = useState(1);
  const [showDropdown, setShowDropdown] = useState(false);
  const [displayedRegular, setDisplayedRegular] = useState([]);
  const [displayedSpecial, setDisplayedSpecial] = useState([]);
  const [displayedSale, setDisplayedSale] = useState([]);

  const itemsPerPage = 50;

  // Suggestion form state
  const [suggestion, setSuggestion] = useState({
    vendorid: shopData?.shopid || "",
    userid: name?._id,
    username: name?.fullname,
    useremail: name?.email,
    role: "",
    imageUrl: userData?.imageUrl || "",
  });

  // Food search results
  const {
    regular: foodsearchregular,
    specialoffer: foodsearchspecial,
    salespromotion: foodsearchsale,
  } = searchResults;

  // Update suggestion state when shop or user data changes
  useEffect(() => {
    setSuggestion((prevState) => ({
      ...prevState,
      imageUrl: userData?.imageUrl || "",
      vendorid: shopData?.shopid || "",
    }));
  }, [userData, shopData]);

  // Filter and organize food items
  useEffect(() => {
    if (!foodItems || foodItems.length === 0) {
      setDisplayedRegular([]);
      setDisplayedSpecial([]);
      setDisplayedSale([]);
      return;
    }

    const regularItems = foodItems.filter((item) => {
      const hasSpecialOffers = item.specialOffers && item.specialOffers !== "";
      const hasSalesPromotion =
        item.salesPromotion && item.salesPromotion !== "";
      // Include item in regular if it has neither special offers nor sales promotion
      return !hasSpecialOffers && !hasSalesPromotion;
    });

    const specialOfferItems = foodItems.filter((item) => {
      return item.specialOffers && item.specialOffers !== "";
    });

    const salesPromotionItems = foodItems.filter((item) => {
      return item.salesPromotion && item.salesPromotion !== "";
    });

    setDisplayedRegular(regularItems);
    setDisplayedSpecial(specialOfferItems);
    setDisplayedSale(salesPromotionItems);
  }, [foodItems]);

  // Handlers
  const handleClosepeople = () => setShowpeoplerating(false);
  const handleShowpeople = () => setShowpeoplerating(true);

  const handleCloseshare = () => setShowshare(false);
  const handleShowshare = () => {
    setShowshare(true);
    setShow(false);
  };
  const handleClosemodal = () => setShow(false);
  const handleShowmodal = () => setShow(true);

  const handleShow = () => setShowavaliable(true);

  const handleSelect = (k) => {
    if (k === "tab1") {
      handleShow();
      setKey("Connents");
    } else if (k === "Postitems") {
      navigate("/resturent-post-form");
    }
  };

  const handleFocus = () => {
    setShowDropdown(true);
  };

  const handleBlur = () => {
    setTimeout(() => setShowDropdown(false), 100);
  };

  const suggestHandel = (e) => {
    setSuggestion((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const suggestPost = async (e) => {
    setIsloading(true);
    e.preventDefault();

    const result = await handlePostSuggestion(suggestion);

    if (result.success) {
      SuccessNotify("Suggestion Data is posted successfully");
      setSuggestion({
        vendorid: shopData?.shopid || "",
        userid: name?._id,
        username: name?.fullname,
        useremail: name?.email,
        role: "",
        imageUrl: userData?.imageUrl || "",
      });
    } else {
      FailedNotify(result.error || "Failed to post suggestion Data");
    }
    setIsloading(false);
  };

  const handleFilterFood = (value) => {
    filterFood(value);
  };

  // Get shop image with fallback
  const shopImageProps = getImageWithFallback(shopData?.image, "profile");
  const shopImageSrc = shopImageProps.isDummy
    ? dummyezi
    : getAsset(shopData?.image);

  // Function to render item image with fallback
  const getItemImageSrc = (imageUrl) => {
    const imageProps = getImageWithFallback(imageUrl, "item");
    return imageProps.isDummy ? dummyezi : getAsset(imageUrl);
  };

  // `images` is stored as an array and defaults to `[]` (or `[""]`), both of
  // which are truthy — a plain `box?.images` check always rendered the <img>
  // branch even when nothing was actually uploaded. Use the same helper that
  // resolves real image data to decide whether a real image exists.
  const hasItemImage = (imageUrl) =>
    !getImageWithFallback(imageUrl, "item").shouldShowFallback;

  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        show={show}
        handleClosemodal={handleClosemodal}
        handleShowshare={handleShowshare}
        shopid={shopid}
      />
      <Suggestionbox
        lgShow={lgShow}
        setLgShow={setLgShow}
        suggestion={suggestion}
        suggestHandel={suggestHandel}
        suggestPost={suggestPost}
      />

      <ConnectProfileModal
        connectbuyModal={showconnect}
        setConnectbuyModal={setShowconnect}
        shopData={shopData}
      />
      <PeopleRatingsModal
        show={showpeoplerating}
        handleClosepeople={handleClosepeople}
      />

      <RatingModel setSmShow={setSmShow} smShow={smShow} shopid={shopid} />
      <Reportbox
        lgshowreport={lgShowreport}
        setLgShowreport={setLgShowreport}
        shopid={shopid}
      />
      <Reportselectezibox
        selectezireport={selectezireport}
        setSelectezireport={setSelectezireport}
        shopid={shopid}
      />

      {Open && <Updatefoodform setOpen={setOpen} Open={Open} />}
      <Container>
        <div className="screenHeight">
          <div
            className="border b-radius mx-auto servicesHeight col-lg-11 mx-auto pt-2 pb-2 ps-5 pe-5 food-shop-content"
            style={{ backgroundColor: "#fafafa" }}
          >
            <style>
              {`
                .img-container {
                  position: relative;
                  width: 100%;
                  height: 150px;
                  overflow: hidden;
                  border-radius: 6px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background-color: #f0f0f0;
                }
                .img-container img {
                  object-fit: cover;
                  border-radius: 6px;
                  width: 100%;
                  height: 100%;
                }
                .img-container .no-image-placeholder {
                  text-align: center;
                  color: #999;
                  font-size: 12px;
                  padding: 20px;
                }
                .card-row {
                  min-height: 150px;
                  display: flex;
                  align-items: center;
                }
                .sales, .salestwo {
                  position: absolute;
                  top: 0px;
                  left: 10px;
                  background-color: red;
                  color: white;
                  padding: 5px 10px;
                  border-radius: 4px;
                  font-size: 12px;
                  z-index: 1;
                }
                
                @media (max-width: 768px) {
                  .img-container {
                    height: 100px;
                  }
                  .card-row {
                    min-height: 120px;
                  }
                }

                .food-items-section > .nav-tabs {
                  padding-right: 230px;
                }
                .food-items-section > .search-absolute {
                  top: 0;
                  right: 0;
                  width: 220px;
                }
                .food-items-section .search-buing-area {
                  width: 100%;
                }

                @media (max-width: 575.98px) {
                  .food-shop-content {
                    padding-right: 12px !important;
                    padding-left: 12px !important;
                  }
                  .food-shop-actions {
                    display: grid !important;
                    grid-template-columns: repeat(2, minmax(0, 1fr));
                    gap: 12px 8px;
                    margin: 12px 0 0 0 !important;
                    padding: 12px !important;
                  }
                  .food-shop-actions > [class*="col-"] {
                    width: auto !important;
                    max-width: none !important;
                    flex: none !important;
                    margin: 0 !important;
                    padding: 0 4px !important;
                  }
                  .food-shop-actions .food-shop-action-link {
                    display: flex;
                    align-items: flex-start;
                    gap: 4px;
                    font-size: 11px;
                    line-height: 1.25;
                    overflow-wrap: anywhere;
                  }
                  .food-shop-actions .food-shop-action-link svg {
                    flex: 0 0 18px;
                    font-size: 18px !important;
                  }
                  .food-items-section {
                    display: flex;
                    flex-direction: column;
                  }
                  .food-items-section > .nav-tabs {
                    order: 1;
                    flex-wrap: nowrap;
                    overflow-x: auto;
                    padding-right: 0;
                    scrollbar-width: thin;
                  }
                  .food-items-section > .nav-tabs .nav-link {
                    flex: 0 0 auto;
                    padding: 0.4rem 0.55rem;
                    font-size: 12px;
                    white-space: nowrap;
                  }
                  .food-items-section > .search-absolute {
                    position: static !important;
                    order: 2;
                    width: 100%;
                    margin: 0 0 0.75rem;
                  }
                  .food-items-section > .tab-content {
                    order: 3;
                    width: 100%;
                  }
                  .back-share-row {
                    padding-left: 8px !important;
                    padding-right: 8px !important;
                  }
                  .back-share-row > [class*="col-"] {
                    padding-left: 8px !important;
                    padding-right: 8px !important;
                  }
                  .food-card-header-row > [class*="col-"] {
                    padding-left: 12px !important;
                    padding-right: 12px !important;
                  }
                }
              `}
            </style>
            <Row className="mb-3 back-share-row align-items-center">
              <Col xs="auto" className="ps-0">
                <BackArrow />
              </Col>
              <Col className="text-end pe-0">
                <button
                  className="text-white bg-blue  rounded mt-2 pt-1 pb-1 ps-4 pe-4"
                  style={{
                    backgroundColor: "#0353a4",
                    border: "none",
                    fontSize: "11px",
                  }}
                  onClick={handleShowmodal}
                >
                  Share <RedoIcon className="share_icon_f" />
                </button>
              </Col>
            </Row>

            {/* Profile Header */}
            <Row className="profile-header align-items-start bg-white p-4 rounded">
              <Col xs={12} md={2} className="text-center">
                <img
                  src={shopImageSrc}
                  alt={shopData?.shopname || "Shop"}
                  className="profile-photo rounded-circle mb-3"
                  crossOrigin="anonymous"
                  onError={(e) => {
                    e.target.src = dummyezi;
                  }}
                />
              </Col>
              <Col xs={12} md={10}>
                <Row>
                  <Col md={8}>
                    <h4 className="mb-0">{shopData?.shopname}</h4>
                    <p className="text-muted mb-0">
                      {" "}
                      <b>Profile ID :</b>
                      {shopData?.shopid ? btoa(shopData.shopid) : ""}
                    </p>
                    <p className="text-muted mb-0">{shopData?.shopaddress}</p>

                    <div className="d-flex align-items-center mb-2">
                      <div className="d-flex">
                        {showrating && showrating > 0 ? (
                          <div className="d-flex">
                            <GradeIcon fontSize="small" />
                            <p className="mb-1 font_small">
                              <Typography
                                component="legend"
                                className="font_small mt-1 "
                              >
                                <b>{showrating}</b>
                              </Typography>
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                        &nbsp;&nbsp;
                        <button
                          className="text-white rounded pt-0 pb-0 ps-3 pe-3 border-0 font_11"
                          style={{ backgroundColor: "#0353a4" }}
                          onClick={handleShowpeople}
                        >
                          View Rating
                        </button>
                      </div>
                    </div>
                  </Col>
                  <Col
                    md={4}
                    className="text-end d-flex flex-column justify-content-start"
                  >
                    <Col lg="2" className="mt-3 mb-2 ms-auto">
                      {showqr == 1 && (
                        <QRCode
                          size={256}
                          style={{
                            height: "auto",
                            maxWidth: "100%",
                            width: "100%",
                          }}
                          value={`https://selectezi.com/${shopid ? btoa(shopid) : ""}`}
                          viewBox={`0 0 256 256`}
                        />
                      )}
                    </Col>

                    <Row>
                      <Col lg="6">
                        <Button
                          variant="primary "
                          className="w-100 mb-2 pt-1 pb-1"
                        >
                          <ChatBubbleIcon fontSize="small" /> Message
                        </Button>
                      </Col>

                      <Col lg="6">
                        <Button
                          variant="primary "
                          className=" w-100 mb-2 pt-1 pb-1"
                        >
                          <CallIcon fontSize="small" />
                          Call
                        </Button>
                      </Col>
                    </Row>

                    <Button variant="primary">View Consultancy Services</Button>
                  </Col>
                </Row>
              </Col>
            </Row>

            {/* Tabs */}
            <Row className="tabs-row food-shop-actions bg-white p-3 rounded mt-3 justify-content-between">
              <Col lg="2" xs="auto" className="me-4">
                <span
                  role="button"
                  className="font_13 food-shop-action-link"
                  onClick={() => setSmShow(true)}
                >
                  <StarIcon style={{ color: "#ffc107" }} /> Rate this Shop
                </span>
              </Col>
              <Col lg="2" xs="auto" className="me-4 p-0">
                {/* No "Connected" state here on purpose — once accepted, this
                    should keep behaving like a normal, clickable connect
                    action instead of locking into a static "Connected" label. */}
                <span
                  role="button"
                  className="font_13 food-shop-action-link"
                  style={
                    isThisShopRequested
                      ? { color: "#856404", cursor: "default" }
                      : undefined
                  }
                  onClick={() => setShowconnect(true)}
                >
                  <ShareIcon
                    style={{
                      color: isThisShopRequested ? "#0353a4" : "#0353a4",
                    }}
                  />{" "}
                  {isThisShopRequested ? "Send Connection Request" : "Send Connection Request"}
                </span>
              </Col>
              <Col lg="2" xs="auto" className="me-4 p-0">
                <span
                  role="button"
                  className="font_13 food-shop-action-link"
                  onClick={() => setLgShow(true)}
                >
                  <CampaignIcon style={{ color: "green" }} /> Suggestion to
                  Owner
                </span>
              </Col>
              <Col lg="2" xs="auto">
                <span
                  role="button"
                  className="font_13 food-shop-action-link"
                  onClick={() => setLgShowreport(true)}
                >
                  <ReportProblemIcon style={{ color: "orange" }} /> Report to
                  Owner
                </span>
              </Col>

              <Col lg="2" xs="auto">
                <span
                  role="button"
                  className="font_13 food-shop-action-link"
                  onClick={() => setSelectezireport(true)}
                >
                  <ReportIcon style={{ color: "red" }} /> Report to Selectezi
                </span>
              </Col>
            </Row>

            <Col lg="12" className="mt-4 position-relative food-items-section">
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => {
                  setKey(k);
                  handleSelect(k);
                }}
                className="mb-3 ms-1"
              >
                <Tab
                  eventKey="home"
                  title="Regular Items"
                  className="resturent-height noscroll"
                >
                  {foodItemsLoading ? (
                    <div className="p-4 text-center">Loading items...</div>
                  ) : (
                    <>
                      {(() => {
                        const data =
                          foodsearchregular && foodsearchregular?.length > 0
                            ? foodsearchregular
                            : displayedRegular;

                        if (!data || data.length === 0) {
                          return (
                            <div className="p-4 text-center">
                              No items found
                            </div>
                          );
                        }

                        const indexOfLastItem =
                          currentPageRegular * itemsPerPage;
                        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
                        const currentItems = data.slice(
                          indexOfFirstItem,
                          indexOfLastItem,
                        );
                        return currentItems?.map((box) => (
                          <Row
                            key={box._id}
                            className="m-1 rounded bg-white mt-2 p-0 m-0 card-row"
                            style={{
                              boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)",
                            }}
                          >
                            <Col className="ps-0" lg="4" xl="4">
                              <div className="img-container">
                                {hasItemImage(box?.images) ? (
                                  <img
                                    className="w-100"
                                    src={getItemImageSrc(box?.images)}
                                    alt={box?.dishname}
                                    crossOrigin="anonymous"
                                    onError={(e) => {
                                      e.target.src = dummyezi;
                                    }}
                                  />
                                ) : (
                                  <div className="no-image-placeholder">
                                    No Image Found
                                  </div>
                                )}
                              </div>
                            </Col>
                            <Col className="" lg="8" xl="8">
                              <div className="row h-100 d-flex flex-column justify-content-center">
                                <div className="row g-2 align-items-center mt-4 food-card-header-row">
                                  <div className="col-12 col-md-4 p-0">
                                    <h6 className="ms-3 mb-0 text-break">
                                      {box?.dishname}
                                    </h6>
                                  </div>
                                  <div className="col-12 col-md-5 p-0">
                                    <h6 className="mb-0">
                                      Preparation Time: {box?.preparationTime}
                                    </h6>
                                  </div>
                                  <div className="col-12 col-md-3 d-flex align-items-center justify-content-md-end">
                                    <h6 className="mb-0 me-1">Rating</h6>
                                    <Rating
                                      name="read-only"
                                      readOnly
                                      size="small"
                                    />
                                  </div>
                                </div>
                                <div className="row mt-2 flex-grow-1">
                                  <div className="col-12">
                                    <h6 className="ms-1 mt-2">Description</h6>
                                    <p className="ms-1 mt-2 font_14">
                                      {box?.description}
                                    </p>
                                  </div>
                                </div>

                                <div className="col-12">
                                  <button
                                    className="mb-2 viewshopnew "
                                    onClick={() => {
                                      setOpen(box?._id);
                                    }}
                                  >
                                    View
                                  </button>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        ));
                      })()}
                    </>
                  )}
                  <div className="pagination d-flex justify-content-center mt-3">
                    <Pagination>
                      {(() => {
                        const data =
                          foodsearchregular && foodsearchregular?.length > 0
                            ? foodsearchregular
                            : displayedRegular;
                        const pageCount = Math.ceil(data.length / itemsPerPage);
                        const items = [];
                        for (let index = 1; index <= pageCount; index++) {
                          items.push(
                            <Pagination.Item
                              key={index}
                              active={index === currentPageRegular}
                              onClick={() => setCurrentPageRegular(index)}
                            >
                              {index}
                            </Pagination.Item>,
                          );
                        }
                        return items;
                      })()}
                    </Pagination>
                  </div>
                </Tab>
                <Tab
                  eventKey="saleitems"
                  title="Sales Promotion"
                  className="resturent-height noscroll"
                >
                  {(() => {
                    const data =
                      foodsearchsale && foodsearchsale?.length > 0
                        ? foodsearchsale
                        : displayedSale;
                    const indexOfLastItem = currentPageSale * itemsPerPage;
                    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
                    const currentItems = data.slice(
                      indexOfFirstItem,
                      indexOfLastItem,
                    );
                    return currentItems?.map((box) => (
                      <Row
                        key={box._id}
                        className="m-1 rounded bg-white mt-2 p-0 m-0 card-row"
                        style={{
                          boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)",
                        }}
                      >
                        <Col className="ps-0" lg="4" xl="4">
                          <div className="position-relative img-container">
                            <div className="salestwo">
                              Sales {box?.salesPromotion}
                            </div>
                            {hasItemImage(box?.images) ? (
                              <img
                                className="w-100"
                                src={getItemImageSrc(box?.images)}
                                alt={box?.dishname}
                                crossOrigin="anonymous"
                                onError={(e) => {
                                  e.target.src = dummyezi;
                                }}
                              />
                            ) : (
                              <div className="no-image-placeholder">
                                No Image Found
                              </div>
                            )}
                          </div>
                        </Col>
                        <Col className="" lg="8" xl="8">
                          <div className="row h-100 d-flex flex-column justify-content-center">
                            <div className="row g-2 align-items-center mt-4 food-card-header-row">
                              <div className="col-12 col-md-4 p-0">
                                <h6 className="ms-3 mb-0 text-break">{box?.dishname}</h6>
                              </div>
                              <div className="col-12 col-md-5 p-0">
                                <h6 className="mb-0">
                                  Preparation Time: {box?.preparationTime}
                                </h6>
                              </div>
                              <div className="col-12 col-md-3 d-flex align-items-center justify-content-md-end">
                                <h6 className="mb-0 me-1">Rating</h6>
                                <Rating
                                  name="read-only"
                                  readOnly
                                  size="small"
                                />
                              </div>
                            </div>
                            <div className="row mt-2 flex-grow-1">
                              <div className="col-12">
                                <h6 className="ms-1 mt-2">Description</h6>
                                <p className="ms-1 mt-2 font_14">
                                  {box?.description}
                                </p>
                              </div>
                            </div>

                            <div className="col-12">
                              <button
                                className="mb-2 viewshopnew"
                                onClick={() => {
                                  setOpen(box?._id);
                                }}
                              >
                                View
                              </button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ));
                  })()}
                  <div className="pagination d-flex justify-content-center mt-3">
                    <Pagination>
                      {(() => {
                        const data =
                          foodsearchsale && foodsearchsale?.length > 0
                            ? foodsearchsale
                            : displayedSale;
                        const pageCount = Math.ceil(data.length / itemsPerPage);
                        const items = [];
                        for (let index = 1; index <= pageCount; index++) {
                          items.push(
                            <Pagination.Item
                              key={index}
                              active={index === currentPageSale}
                              onClick={() => setCurrentPageSale(index)}
                            >
                              {index}
                            </Pagination.Item>,
                          );
                        }
                        return items;
                      })()}
                    </Pagination>
                  </div>
                </Tab>

                <Tab
                  eventKey="specialitems"
                  title="Special Offers"
                  className="resturent-height noscroll"
                >
                  {(() => {
                    const data =
                      foodsearchspecial && foodsearchspecial.length > 0
                        ? foodsearchspecial
                        : displayedSpecial;
                    const indexOfLastItem = currentPageSpecial * itemsPerPage;
                    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
                    const currentItems = data.slice(
                      indexOfFirstItem,
                      indexOfLastItem,
                    );
                    return currentItems?.map((box) => (
                      <Row
                        key={box._id}
                        className="m-1 rounded bg-white mt-2 p-0 m-0 card-row"
                        style={{
                          boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)",
                        }}
                      >
                        <Col className="ps-0" lg="4" xl="4">
                          <div className="position-relative img-container">
                            <div className="sales">{box?.specialOffers}</div>
                            {hasItemImage(box?.images) ? (
                              <img
                                className="w-100"
                                src={getItemImageSrc(box?.images)}
                                alt={box?.dishname}
                                crossOrigin="anonymous"
                                onError={(e) => {
                                  e.target.src = dummyezi;
                                }}
                              />
                            ) : (
                              <div className="no-image-placeholder">
                                No Image Found
                              </div>
                            )}
                          </div>
                        </Col>
                        <Col className="" lg="8" xl="8">
                          <div className="row h-100 d-flex flex-column justify-content-center">
                            <div className="row g-2 align-items-center mt-4 food-card-header-row">
                              <div className="col-12 col-md-4 p-0">
                                <h6 className="ms-3 mb-0 text-break">{box?.dishname}</h6>
                              </div>
                              <div className="col-12 col-md-5 p-0">
                                <h6 className="mb-0">
                                  Preparation Time: {box?.preparationTime}
                                </h6>
                              </div>
                              <div className="col-12 col-md-3 d-flex align-items-center justify-content-md-end">
                                <h6 className="mb-0 me-1">Rating</h6>
                                <Rating
                                  name="read-only"
                                  readOnly
                                  size="small"
                                />
                              </div>
                            </div>
                            <div className="row mt-2 flex-grow-1">
                              <div className="col-12">
                                <h6 className="ms-1 mt-2">Description</h6>
                                <p className="ms-1 mt-2 font_14">
                                  {box?.description}
                                </p>
                              </div>
                            </div>

                            <div className="col-12 ">
                              <button
                                className="mb-2 viewshopnew "
                                onClick={() => {
                                  setOpen(box?._id);
                                }}
                              >
                                View
                              </button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ));
                  })()}
                  <div className="pagination d-flex justify-content-center mt-3">
                    <Pagination>
                      {(() => {
                        const data =
                          foodsearchspecial && foodsearchspecial.length > 0
                            ? foodsearchspecial
                            : displayedSpecial;
                        const pageCount = Math.ceil(data.length / itemsPerPage);
                        const items = [];
                        for (let index = 1; index <= pageCount; index++) {
                          items.push(
                            <Pagination.Item
                              key={index}
                              active={index === currentPageSpecial}
                              onClick={() => setCurrentPageSpecial(index)}
                            >
                              {index}
                            </Pagination.Item>,
                          );
                        }
                        return items;
                      })()}
                    </Pagination>
                  </div>
                </Tab>
              </Tabs>
              <div className="position-absolute search-absolute">
                <Form
                  className="position-relative"
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                >
                  <FormControl
                    type="text"
                    placeholder="Search"
                    className="mr-sm-2 search-buing-area"
                    onChange={(e) => handleFilterFood(e.target.value)}
                  />
                </Form>
              </div>
            </Col>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Foodandrestaurantbuy;
